import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailSetup } from '../dto/trail-setup';

@Injectable({
  providedIn: 'root'
})
export class TrailSetupService {

  private apiUrl = environment.apiRoot + '/trialsetup';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trailId: number): Observable<TrailSetup[]> {
    return this.http.get<TrailSetup[]>(this.apiUrl + '/alloftrial?trialId=' + trailId);
  }

  createTrialSetup(trialId: number): Observable<TrailSetup> {
    let model = { "id": 0, "trial_id": trialId, "system_setup": "new setup" };
    return this.http.post<TrailSetup>(this.apiUrl + '/new', model);
  }

  updateTrialSetup(model: TrailSetup): Observable<TrailSetup> {
    return this.http.put<TrailSetup>(this.apiUrl + '/update', model);
  }

  deleteTrialSetup(trialSetuplId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialSetuplId=' + trialSetuplId);
  }
}
